
<div
    v-show="isVisible"
    class="MorphingGhost"
    :class="{ 'is-relative': useRelative }"
    ref="ghost"
    :style="ghostStyle"
></div>
